const KEY = 'acuta.pendingInvitation';

/**
 * Токен приглашения на время регистрации и входа (ADR-0014): человек открыл ссылку, ещё не
 * имея аккаунта. Живёт в sessionStorage — только в этой вкладке и до её закрытия. Хранилище
 * может быть недоступно (приватный режим) — тогда приглашение всё равно ждёт во «входящих».
 */
export function savePendingInvitation(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Без хранилища — без автоматического возврата к приглашению.
  }
}

export function readPendingInvitation(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingInvitation(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Нечего убирать.
  }
}
